import { render } from "./SnackbarStack.vue?vue&type=template&id=1dcdbbc0&scoped=true"
import script from "./SnackbarStack.vue?vue&type=script&lang=js"
export * from "./SnackbarStack.vue?vue&type=script&lang=js"

import "./SnackbarStack.vue?vue&type=style&index=0&id=1dcdbbc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcdbbc0"]])

export default __exports__